import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { API_BASE_URL, INSERT_STORE, UPDATE_STORE } from "../../../Config";
import Axios from "axios";
import PropTypes from "prop-types";
import SpinLoader from "../../../feature-module/loader/SpinLoader";

const StoreModal = ({ storeObj }) => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [viewStoreData, setViewStoreData] = useState([]);

  // console.log(storeObj, 's s s s ss ');
  useEffect(() => {
    setViewStoreData(storeObj);
  }, [storeObj]);

  // #region Session for userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  const [addSubmitBtnLoading, setAddSubmitBtnLoading] = useState(false);

  // region Add Form Data
  const [addFormData, setAddFormData] = useState({
    OrgId: `${userDataSession.OrgId}`,
    Name: "",
    Address: "",
    PhoneNo: "",
    Description: "",
    DefaultTaxInclusive: 0,
    CreatedBy: userDataSession.UserId,
    GSTBillCode: "",
    NonGSTBillCode: "",
    IsMainStore: 0,
    GSTIN: "",
    BankDetails: "",
    EmailId: "",
    State: "",
    City: "",
    StoreNumber: "",
    StoreCode: "",
  });

  const handleAddInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const [objectName, key] = name.split(".");

    const inputValue = type === "checkbox" ? (checked ? 1 : 0) : value;

    if (objectName && key) {
      setAddFormData((prevState) => ({
        ...prevState,
        [objectName]: {
          ...prevState[objectName],
          [key]: inputValue,
        },
      }));
    } else {
      setAddFormData((prevState) => ({
        ...prevState,
        [name]: inputValue,
      }));
    }
  };

  // #region Add store func
  const handleAddSubmit = (e) => {
    e.preventDefault();
    setAddSubmitBtnLoading(true);

    const dataToSubmit = {
      ...addFormData,
      IsMainStore: addFormData.IsMainStore || 0,
      DefaultTaxInclusive: addFormData.DefaultTaxInclusive || 0,
      OrgId: userDataSession.OrgId,
      CreatedBy: userDataSession.UserId,
    };
    console.log(dataToSubmit, "add data sending to api");

    Axios.post(`${API_BASE_URL}${INSERT_STORE}`, dataToSubmit)
      .then((response) => {
        console.log(response.data.ResultData);
        if (response.data.ResultData[0].Status == "Success") {
          setAddSubmitBtnLoading(false);

          // Show success message
          Swal.fire({
            title: `Store added Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          setAddSubmitBtnLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      })

      .catch((error) => {
        setAddSubmitBtnLoading(false);
        // Handle error
        console.error("Error adding category:", error);
      });
  };

  // region Edit Form Data
  const [editFormData, setEditFormData] = useState({
    OrgId: userDataSession.OrgId,
    IsActive: "",
    Name: "",
    Address: "",
    PhoneNo: "",
    Description: "",
    DefaultTaxInclusive: 0,
    CreatedBy: userDataSession.UserId,
    UpdatedBy: userDataSession.UserId,
    GSTBillCode: "",
    NonGSTBillCode: "",
    IsMainStore: 0,
    GSTIN: "",
    BankDetails: "",
    EmailId: "",
    State: "",
    City: "",
    StoreNumber: "",
    StoreCode: "",
  });

  // region Assigning values to edit from data
  useEffect(() => {
    // console.log(viewStoreData)
    if (viewStoreData) {
      setEditFormData({
        Id: viewStoreData.Id,
        OrgId: userDataSession.OrgId,
        Name: viewStoreData.Name,
        IsActive: viewStoreData.IsActive,
        Address: viewStoreData.Address,
        PhoneNo: viewStoreData.PhoneNo,
        Description: viewStoreData.Description,
        DefaultTaxInclusive: viewStoreData.DefaultTaxInclusive ? 1 : 0,
        CreatedBy: viewStoreData.CreatedBy,
        GSTBillCode: viewStoreData.GSTBillCode,
        NonGSTBillCode: viewStoreData.NonGSTBillCode,
        IsMainStore: viewStoreData.IsMainStore ? 1 : 0,
        GSTIN: viewStoreData.GSTIN,
        BankDetails: viewStoreData.BankDetails || "NULL",
        EmailId: viewStoreData.EmailId,
        State: viewStoreData.State,
        City: viewStoreData.City,
        StoreNumber: viewStoreData.StoreNumber,
        StoreCode: viewStoreData.StoreCode,
        UpdatedBy: userDataSession.UserId,
      });
    }
  }, [viewStoreData, userDataSession]);

  const handleEditInputChange = (e) => {
    const { name, type, checked, value } = e.target;
  
    const inputValue = type === "checkbox" ? (checked ? 1 : 0) : value;
  
    setEditFormData((prevState) => ({
      ...prevState,
      [name]: inputValue,
    }));
  };
  
  // region Edit Store Func
  const handleEditSubmit = (e) => {
    e.preventDefault();
    setAddSubmitBtnLoading(true);

    editFormData.OrgId = userDataSession.OrgId;
    editFormData.CreatedBy = userDataSession.UserId;
    editFormData.UpdatedBy = userDataSession.UserId,
    editFormData.GSTBillCode = editFormData.GSTBillCode || "0",
    editFormData.NonGSTBillCode = editFormData.NonGSTBillCode || "0",
    editFormData.IsActive = 1;
    
    const dataToSubmit = {
      ...editFormData,
      // IsMainStore: editFormData.IsMainStore || 0,
      // DefaultTaxInclusive: editFormData.DefaultTaxInclusive || 0,
      OrgId: userDataSession.OrgId,
      CreatedBy: userDataSession.UserId,
      UpdatedBy: userDataSession.UserId,
      IsActive: 1,
    };
    console.log(dataToSubmit, 'edit data sending to edit api');

    Axios.post(`${API_BASE_URL}${UPDATE_STORE}`, dataToSubmit)
      .then((response) => {
        console.log(response.data.ResultData);
        if (response.data.ResultData[0].Status == 'Success') {
          setAddSubmitBtnLoading(false);

          // Show success message
          Swal.fire({
            title: `Store Updated Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          setAddSubmitBtnLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to Request Submit.",
            icon: "error",
          });
        }
      })

      .catch((error) => {
        setAddSubmitBtnLoading(false);
        // Handle error
        console.error("Error adding category:", error);
      });
  };

  return (
    <>
      {/* Add Store */}
      {addSubmitBtnLoading&&(<SpinLoader/>)}
      <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="offcanvasRightAddStore"
          aria-labelledby="offcanvasRightLabel"
          style={{ minWidth: '400px', maxWidth: '50%' }}
      >
          <div className="offcanvas-header">
              <h4 id="offcanvasRightLabel">Add Store</h4>
              <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
              />
          </div> <hr/>
          <div className="offcanvas-body">
            <form onSubmit={handleAddSubmit}>
              <div className="tab-content" id="myTabContent">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="input-blocks">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Name"
                        value={addFormData.Name || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter store name"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input-blocks">
                      <label>Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="StoreCode"
                        value={addFormData.StoreCode || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter phone no"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input-blocks">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="EmailId"
                        value={addFormData.EmailId || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter email"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input-blocks">
                      <label>Phone</label>
                      <input
                        type="number"
                        className="form-control"
                        name="PhoneNo"
                        value={addFormData.PhoneNo || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter phone no"
                        onWheel={(e) => e.target.blur(e)}
                
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input-blocks">
                      <label>GST No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="GSTIN"
                        value={addFormData.GSTIN || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter gst no"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input-blocks">
                      <label>City</label>
                      <input
                        type="text"
                        className="form-control"
                        name="City"
                        value={addFormData.City || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter city"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="input-blocks">
                      <label>State</label>
                      <input
                        type="text"
                        className="form-control"
                        name="State"
                        value={addFormData.State || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter state"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="d-flex justify-content-evenly">
                      <div className="input-blocks">
                        <label htmlFor="ismainstore">Main Store</label>
                        <input
                          type="checkbox"
                          id="ismainstore"
                          name="IsMainStore"
                          checked={addFormData.IsMainStore === 1}
                          onChange={handleAddInputChange}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                      <div className="input-blocks">
                        <label htmlFor="taxinclude">Tax Include</label>
                        <input
                          type="checkbox"
                          id="taxinclude"
                          name="DefaultTaxInclusive"
                          checked={addFormData.DefaultTaxInclusive === 1}
                          onChange={handleAddInputChange}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-blocks">
                      <label>Address</label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="Address"
                        value={addFormData.Address || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter address..."
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="input-blocks">
                      <label>Notes</label>
                      <textarea
                        type="text"
                        className="form-control"
                        name="Description"
                        value={addFormData.Description || ""}
                        onChange={handleAddInputChange}
                        placeholder="Enter notes..."
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-submit">
                  {addSubmitBtnLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      {/* /Add Store */}

      {/* Edit Store */}
      
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditStore"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: '400px', maxWidth: '50%' }}
      >
        <div className="offcanvas-header">
            <h4 id="offcanvasRightLabel">Edit Store</h4>
            <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            />
        </div> <hr/>
        <div className="offcanvas-body">
          <form onSubmit={handleEditSubmit}>
            <div className="row">
              <div className="col-lg-4">
                <div className="input-blocks">
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="Name"
                    value={editFormData.Name || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter store name"
                    required
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="input-blocks">
                  <label>Code</label>
                  <input
                    type="text"
                    className="form-control"
                    name="StoreCode"
                    value={editFormData.StoreCode || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter store code"
                    required
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="input-blocks">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="EmailId"
                    value={editFormData.EmailId || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter email"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="input-blocks">
                  <label>Phone</label>
                  <input
                    type="number"
                    className="form-control"
                    name="PhoneNo"
                    value={editFormData.PhoneNo || ""}
                    onChange={handleEditInputChange}
                    onWheel={(e) => e.target.blur}
                    placeholder="Enter phone no"
              
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="input-blocks">
                  <label>GST No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="GSTIN"
                    value={editFormData.GSTIN || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter gst no"
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="input-blocks">
                  <label>City</label>
                  <input
                    type="text"
                    className="form-control"
                    name="City"
                    value={editFormData.City || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter city"
                    required
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="input-blocks">
                  <label>State</label>
                  <input
                    type="text"
                    className="form-control"
                    name="State"
                    value={editFormData.State || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter state"
                    required
                  />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="d-flex justify-content-evenly">
                  <div className="input-blocks">
                    <label htmlFor="ismainstoreedit">Main Store</label>
                    <input
                      type="checkbox"
                      id="ismainstoreedit"
                      name="IsMainStore"
                      checked={editFormData.IsMainStore === 1}
                      onChange={handleEditInputChange}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className="input-blocks">
                    <label htmlFor="taxincludeedit">Tax Include</label>
                    <input
                      type="checkbox"
                      id="taxincludeedit"
                      name="DefaultTaxInclusive"
                      checked={editFormData.DefaultTaxInclusive === 1}
                      onChange={handleEditInputChange}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="input-blocks">
                  <label>Address</label>
                  <textarea
                    type="text"
                    className="form-control"
                    name="Address"
                    value={editFormData.Address || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter address..."
                  ></textarea>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="input-blocks">
                  <label>Notes</label>
                  <textarea
                    type="text"
                    className="form-control"
                    name="Description"
                    value={editFormData.Description || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter notes..."
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                {addSubmitBtnLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit Store */}

      {/* View Store */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewStore"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: '400px', maxWidth: '50%' }}
      >
        <div className="offcanvas-header">
            <h4 id="offcanvasRightLabel">View Store</h4>
            <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            />
        </div> <hr/>
        <div className="offcanvas-body">
          <form>
            <div className="tab-content" id="myTabContent">
              <div className="row">
                <div className="col-lg-6">
                  <div className="input-blocks">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={viewStoreData?.Name || ""}
                      placeholder="Store name"
                      readOnly
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="input-blocks">
                    <label>Code</label>
                    <input
                      type="text"
                      className="form-control"
                      value={viewStoreData?.StoreCode || ""}
                      placeholder="Store name"
                      readOnly
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="input-blocks">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={viewStoreData?.EmailId || ""}
                      placeholder="Store email"
                      readOnly
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="input-blocks">
                    <label>Phone No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={viewStoreData?.PhoneNo || ""}
                      readOnly
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="input-blocks">
                    <label>GSTIN</label>
                    <input
                      type="text"
                      className="form-control"
                      value={viewStoreData?.GSTIN || ""}
                      readOnly
                    />
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="input-blocks">
                    <label>State</label>
                    <input
                      type="text"
                      className="form-control"
                      value={viewStoreData?.State || ""}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="input-blocks">
                    <label>City</label>
                    <input
                      type="text"
                      className="form-control"
                      value={viewStoreData?.City || ""}
                      readOnly
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                <div className="d-flex justify-content-evenly">
                  <div className="input-blocks">
                    <label htmlFor="ismainstoreedit">Main Store</label>
                    <input
                      type="checkbox"
                      id="ismainstoreedit"
                      checked={viewStoreData?.IsMainStore}
                    />
                  </div>
                  <div className="input-blocks">
                    <label htmlFor="taxincludeedit">Tax Include</label>
                    <input
                      type="checkbox"
                      id="taxincludeedit"
                      checked={viewStoreData?.DefaultTaxInclusive}
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="input-blocks">
                  <label>Address</label>
                  <textarea
                    type="text"
                    className="form-control"
                    name="Address"
                    value={editFormData.Address || ""}
                    onChange={handleEditInputChange}
                    placeholder="Enter address..."
                  ></textarea>
                </div>
              </div>
                <div className="col-lg-6">
                  <div className="input-blocks">
                    <label>Notes</label>
                    <textarea
                      className="form-control"
                      value={viewStoreData?.Description || ""}
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* /View Customer */}
    </>
  );
};

StoreModal.propTypes = {
  storeObj: PropTypes.array.isRequired,
};

export default StoreModal;
